import * as $ from 'jquery';
import * as Clipboard from 'clipboard';

export const shareModal = () => {
    console.log('share modal loaded');

    window.addEventListener('load', function () {
        const hasElement = document.getElementsByClassName('share')
        if (hasElement.length > 0) {
            // Share Modal
            $(".share").click(function(){
                console.log('clicked');
                var id = $(this).attr("entry-id")
                $('body').css('overflow','hidden')
                $("#share-modal"+id).fadeIn( "slow" ).css("display","flex");
            });
                
            $(".modal-close-outside").click(function(){
                // $(".modal").css("display","none");
                $('.modal').fadeOut( "slow" );
                $('body').css('overflow','unset')
            });
            // Copy to Clipboard (Clipboard.js)
            var clipboard = new Clipboard('.copy-btn');

            $(".copy-btn").click(function(){
                console.log('copy yo');
                let id =  $(this).attr('id');
                $('#success'+id).show()
            })

            htmx.on('htmx:afterSettle', function(event) { 
                $(".share").click(function(){
                    console.log('after filter clicked');
                    var id = $(this).attr("entry-id")
                    $('body').css('overflow','hidden')
                    $("#share-modal"+id).fadeIn( "slow" ).css("display","flex");
                });
                    
                $(".modal-close-outside").click(function(){
                    $('.modal').fadeOut( "slow" );
                    $('body').css('overflow','unset')
                });
                // Copy to Clipboard (Clipboard.js)
                var clipboard = new Clipboard('.copy-btn');
        
                $(".copy-btn").click(function(){
                    console.log('copy yo');
                    let id =  $(this).attr('id');
                    $('#success'+id).show()
                })
            });
        }
    });

};
